// middleware/access-gate.global.ts
// Simple pre-launch gate: redirects unauthenticated visitors to /coming-soon.
// Google crawlers are allowed through so ads.txt verification and AdSense approval work.
export default defineNuxtRouteMiddleware((_to) => {
  // Gate disabled — remove this return to re-enable
  return;

  // // Never gate the coming-soon page itself (infinite redirect)
  // if (to.path === '/coming-soon') return

  // // Allow static files and healthz
  // if (to.path === '/healthz') return

  // // SSR: let search engine bots and social media crawlers through
  // // so OG tags, link previews, AdSense/Google verification all work
  // if (import.meta.server) {
  //   const event = useRequestEvent()
  //   const ua = event?.node?.req?.headers?.['user-agent'] || ''
  //   if (/googlebot|mediapartners-google|adsbot-google|bingbot|facebookexternalhit|facebookcatalog|whatsapp|twitterbot|telegrambot|slackbot|slack-imgproxy|linkedinbot|discordbot|pinterestbot|applebot|snapchat|viber|redditbot/i.test(ua)) return
  // }

  // // Check access cookie
  // const access = useCookie('site-access')
  // if (access.value === 'granted') return

  // // Not granted → redirect, preserving original destination
  // const redirect = to.fullPath !== '/coming-soon' ? to.fullPath : undefined
  // return navigateTo(redirect ? `/coming-soon?redirect=${encodeURIComponent(redirect)}` : '/coming-soon')
});
